import React, { useEffect, useState } from "react";
import FromToRangeInput from "../../components/input/FromToRangeInput";
import GlobalFilter from "../../components/GlobalFilter/GlobalFilter";
import { useGetDimonListMutation } from "../../store/api/filterApi";
import DiamondGridView from "./DiamondGridView";
import DiamondListView from "./DiamondListView";
import "./CertifiedDimonds.css";
import Loader from "../../components/common/Loader";
import { useDispatch, useSelector } from "react-redux";
import {
  addFilterToApply,
  resetFilterState,
} from "../../store/slices/filterSlice";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import Switch from "../../components/input/Switch";
import BannerHeader from "../../components/BannerHeader/BannerHeader";

const CertifiedDiamonds = () => {
  const dispatch = useDispatch();
  const [isGrid, setIsGrid] = useState(true);
  const filterToApply = useSelector((state) => state?.filter?.filterToApply);
  const filtersFromRedux = useSelector((state) => state?.filter);
  const [dimondList, setDimondList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const [
    getDimondListBasedOnFilter,
    { data: dimondListData, isLoading: dimonListLoading },
  ] = useGetDimonListMutation();

  useEffect(() => {
    setError(null);
    getDimondListBasedOnFilter({ ...filterToApply })
      .unwrap()
      .then((result) => {
        setDimondList(result?.data);
      })
      .catch((err) => {
        setError(err?.message || JSON.stringify(err));
        console.error("Diamond List API Error:", err);
      });
  }, [filterToApply]);

  const handleApplyFilter = () => {
    let filters = JSON.parse(JSON.stringify(filtersFromRedux));
    delete filters.filterToApply;
    dispatch(addFilterToApply({ ...filters, pageNumber: 1, pageSize: 20 }));
  };

  const handleResetFilters = () => {
    dispatch(resetFilterState());
  };

  const handlePageChange = (e) => {
    let filters = JSON.parse(JSON.stringify(filtersFromRedux));
    delete filters.filterToApply;
    setCurrentPage(e);
    dispatch(addFilterToApply({ ...filters, pageNumber: e, pageSize: 20 }));
  };

  const totalRecords = Math.floor(dimondList?.totalCount / 20);

  return (
    <div>
      <BannerHeader />
      <GlobalFilter />
      <div className="container my-4 d-flex filter-buttons">
        <button
          className="common-button button-bordered"
          onClick={handleResetFilters}
        >
          Reset Selection
        </button>
        <button
          className="common-button button-filled"
          onClick={handleApplyFilter}
        >
          Search
        </button>
      </div>
      <div className="custom-container my-4 main-list-view  position-relative">
        <div className="item-count align-items-center d-flex w-100 justify-content-between">
          Total {dimondList?.totalCount} Products
          <Switch onChange={(e) => setIsGrid(e)} />
        </div>
        {/* {error && (
          <div style={{ color: "red", fontWeight: 600, marginBottom: 16 }}>
            Error: {error}
          </div>
        )} */}

        {dimonListLoading && <Loader />}
        {isGrid ? (
          <DiamondGridView
            dimonListLoading={dimonListLoading}
            dimondListData={dimondList}
          />
        ) : (
          <DiamondListView
            diamonds={dimondList?.inventory}
            dimonListLoading={dimonListLoading}
          />
        )}
        {!dimonListLoading && (
          <div className="pagination">
            <Pagination
              total={totalRecords}
              current={currentPage}
              onChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CertifiedDiamonds;
